import React from 'react';
import elencoSettori from '../data/ElencoSettori';

const SettoriContext = React.createContext(elencoSettori);

export { SettoriContext as default };
